import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=12a078fd&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=12a078fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a078fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a078fd')) {
      api.createRecord('12a078fd', component.options)
    } else {
      api.reload('12a078fd', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=12a078fd&scoped=true&", function () {
      api.rerender('12a078fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hfYJKuXGU71W/JS/comp/SearchFilterTokens.vue"
export default component.exports